export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "content",
        component: resolve => require(["@/views/content/index.vue"], resolve),
        children: [
          {
            path: "case/list",
            name: "caseList",
            component: resolve => require(["@/modules/case/pages/list.vue"], resolve)
          },
          {
            path: "case/edit/:id",
            name: "caseEdit",
            component: resolve => require(["@/modules/case/pages/edit.vue"], resolve)
          },
          {
            path: "case/type",
            name: "caseType",
            component: resolve => require(["@/modules/case/pages/type.vue"], resolve)
          },
          {
            path: "case/banner",
            name: "caseBanner",//方案专题
            component: resolve => require(["@/modules/case/pages/banner.vue"], resolve)
          },
          {
            path: "case/subject",
            name: "caseSubject",//编辑专题
            component: resolve => require(["@/modules/case/pages/subject.vue"], resolve)
          },
          {
            path: "case/listall",
            name: "caseListAll",//方案池
            component: resolve => require(["@/modules/case/pages/listall.vue"], resolve)
          }
        ]
      }
    ]
  }
];